// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gridCard--MADWd {
  width: 100%;
  height: 100%;
  position: relative;
  min-height: 300px;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
  display: grid;
  grid-template-rows: minmax(min-content, max-content) minmax(min-content, max-content) auto auto;
  align-content: stretch;
  border-radius: 0.25rem;
}
.gridCard--MADWd:hover .playerBadge--LpsG_ {
  z-index: 3;
}
.playerBadge--LpsG_ {
  position: absolute;
  top: 0.45rem;
  right: 0.45rem;
  border-radius: 0.25rem;
  background-color: #FFF;
  padding: 0 0.35rem;
  border: 2px #00217D solid;
}
.playerBadge--LpsG_ svg {
  margin-right: 2px;
}
.header--HUKA8 {
  padding: 0.25rem;
  height: auto;
}
.header--HUKA8 a {
  color: #1A202C !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.header--HUKA8 a:focus {
  background-color: unset;
}
.videoSubheader--qTjvM {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  color: #495A7C;
  margin: 0 0.25rem;
  align-items: center;
  overflow: hidden;
}
.videoSubheader--qTjvM > button {
  position: relative;
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}
.videoSubheader--qTjvM > button .createdBy--Xv5gf {
  color: var(--gray-900);
}
.videoSubheader--qTjvM > button .createdBy--Xv5gf:hover {
  text-decoration-line: underline;
  text-decoration-style: solid;
}
.videoSubheader--qTjvM > button .createdBy--Xv5gf {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.videoSubheader--qTjvM > button:before {
  height: 24px;
  content: '•';
  color: #00217D;
  padding-right: 4px;
  line-height: 1.5rem;
  font-size: 1rem;
  z-index: 1;
}
.videoSubheader--qTjvM > button:only-child:before {
  content: none;
}
.videoSubheader--qTjvM > span {
  --bo-ui-badge-margin: 0;
  --bo-ui-badge-padding: 2px 4px 2px 4px;
  position: relative;
  padding: 0 0.25rem;
  height: 24px;
  display: flex;
  align-items: center;
}
.videoSubheader--qTjvM > span:nth-child(n + 2) {
  margin-left: 8px;
}
.videoSubheader--qTjvM > span:nth-child(n + 2):before {
  height: 24px;
  content: '•';
  color: #00217D;
  line-height: 1.5rem;
  font-size: 1rem;
  z-index: 1;
  position: absolute;
  left: -10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/gridCard/style.module.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iDAAA;EACA,aAAA;EACA,+FAAA;EAGA,sBAAA;EACA,sBAAA;AAHF;AAKE;EAEI,UAAA;AAJN;AASA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAPF;AAAA;EASI,iBAAA;AANJ;AAUA;EACE,gBAAA;EACA,YAAA;AARF;AAMA;EAKI,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AARJ;AAUI;EACE,uBAAA;AARN;AAaA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAXF;AAIA;EAUI,kBAAA;EACA,OAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AAXJ;AAcM;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AApBN;EAqBM,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAXN;AAcI;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAZN;AAgBM;EACE,aAAA;AAdR;AAzBA;EA6CI,uBAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAjBJ;AAmBI;EACE,gBAAA;AAjBN;AAmBM;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AAjBR","sourcesContent":["@import '~@boclips-ui/styles/src/colors';\n\n.gridCard {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  min-height: 300px;\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);\n  display: grid;\n  grid-template-rows:\n    minmax(min-content, max-content) minmax(min-content, max-content)\n    auto auto;\n  align-content: stretch;\n  border-radius: 0.25rem;\n\n  &:hover {\n    .playerBadge {\n      z-index: 3;\n    }\n  }\n}\n\n.playerBadge {\n  position: absolute;\n  top: 0.45rem;\n  right: 0.45rem;\n  border-radius: 0.25rem;\n  background-color: @white;\n  padding: 0 0.35rem;\n  border: 2px @blue-800 solid;\n  svg {\n    margin-right: 2px;\n  }\n}\n\n.header {\n  padding: 0.25rem;\n  height: auto;\n\n  a {\n    color: @gray-900 !important;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n\n    &:focus {\n      background-color: unset;\n    }\n  }\n}\n\n.videoSubheader {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  color: @gray-700;\n  margin: 0 0.25rem;\n  align-items: center;\n  overflow: hidden;\n\n  >button {\n    position: relative;\n    flex: 1;\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: flex;\n    align-items: center;\n\n    .createdBy {\n      @apply text-gray-900 hover:underline hover:decoration-solid;\n      max-width: 100%;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    &:before {\n      height: 24px;\n      content: '•';\n      color: @blue-800;\n      padding-right: 4px;\n      line-height: 1.5rem;\n      font-size: 1rem;\n      z-index: 1;\n    }\n\n    &:only-child {\n      &:before {\n        content: none;\n      }\n    }\n  }\n\n  >span {\n    --bo-ui-badge-margin: 0;\n    --bo-ui-badge-padding: 2px 4px 2px 4px;\n    position: relative;\n    padding: 0 0.25rem;\n    height: 24px;\n    display: flex;\n    align-items: center;\n\n    &:nth-child(n + 2) {\n      margin-left: 8px;\n\n      &:before {\n        height: 24px;\n        content: '•';\n        color: @blue-800;\n        line-height: 1.5rem;\n        font-size: 1rem;\n        z-index: 1;\n        position: absolute;\n        left: -10px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridCard": `gridCard--MADWd`,
	"playerBadge": `playerBadge--LpsG_`,
	"header": `header--HUKA8`,
	"videoSubheader": `videoSubheader--qTjvM`,
	"createdBy": `createdBy--Xv5gf`
};
export default ___CSS_LOADER_EXPORT___;
